import { render, staticRenderFns } from "./StockTransfer.vue?vue&type=template&id=0102dbc6&"
import script from "./StockTransfer.vue?vue&type=script&lang=js&"
export * from "./StockTransfer.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Volumes/Ramon/PROYECTOS/JuanGabriel_POS/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('0102dbc6')) {
      api.createRecord('0102dbc6', component.options)
    } else {
      api.reload('0102dbc6', component.options)
    }
    module.hot.accept("./StockTransfer.vue?vue&type=template&id=0102dbc6&", function () {
      api.rerender('0102dbc6', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/js/components/admin/StockTransfer.vue"
export default component.exports